module.exports = __webpack_public_path__ + "static/media/ua.a2d03e14.svg";